import script from "./ClientCabinetQuickActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetQuickActions.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetQuickActions.vue?vue&type=style&index=0&id=42c90683&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42c90683"]])

export default __exports__